import { useReducer, useMemo, createContext, useContext, useState } from "react"
import { getInfo, setInfo, getSignKey, saveSignKey, saveExpireSignKey } from "lib/Cookies"
import { apiSubscription } from "api"
import KEY from "./Const"

const dfUserInfo = {}
const dfModal = {
  display: false,
  type: "",
  customMessage: "",
  onButtonClick: () => null,
  onCancelClick: () => null
}

function initialState() {
  return {
    userInfo: getInfo() || dfUserInfo,
    modal: dfModal,
    isShowModalLogin: false,
    signKey: getSignKey(),
    modalLive: {
      show: false,
      info: {}
    },
    modalBan: {
      show: false,
      info: {}
    }
  }
}

function reducer(state, action) {
  // debugger
  switch (action.type) {
    case KEY.SET_USER:
      return { ...state, userInfo: action.value ? action.value : dfUserInfo }
    case KEY.SHOW_MODAL:
      return { ...state, modal: { ...dfModal, ...action.value, display: true } }
    case KEY.CLOSE_MODAL:
      return { ...state, modal: dfModal }
    case KEY.MODAL_LOGIN:
      return { ...state, isShowModalLogin: !state.isShowModalLogin }
    case KEY.MODAL_LIVE:
      return { ...state, modalLive: action.value }
    case KEY.MODAL_BAN:
      return { ...state, modalBan: action.value }
    case KEY.SIGN_KEY:
      return { ...state, signKey: action.value }
    case KEY.LOG_OUT:
      return initialState()
    default:
      throw new Error()
  }
}

const MyContext = createContext(initialState())
MyContext.displayName = "MyContext"

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState())
  const [isRedirectEvent, setIsRedirectEvent] = useState(false)
  const [dataEvent, setDataEvent] = useState([])
  const [dataSubscription, setDataSubscription] = useState([])
  const setUser = (value) => {
    setInfo(value)
    return dispatch({ type: KEY.SET_USER, value })
  }
  const showModal = (value) => dispatch({ type: KEY.SHOW_MODAL, value })
  const closeModal = () => dispatch({ type: KEY.CLOSE_MODAL })
  const toggleModalLogin = () => dispatch({ type: KEY.MODAL_LOGIN })
  const setModalLive = (value) => dispatch({ type: KEY.MODAL_LIVE, value })
  const setModalBan = (value) => dispatch({ type: KEY.MODAL_BAN, value })
  const logOut = () => dispatch({ type: KEY.LOG_OUT })
  const setSignKey = async (dataBody) => {
    let signKey = ""
    try {
      const { data } = await apiSubscription.getKey(dataBody)
      signKey = data?.sign_key
      saveSignKey(signKey)
      saveExpireSignKey(data?.exp)
      dispatch({ type: KEY.SIGN_KEY, value: signKey })
    } catch (e) {
      // console.log(e.response?.status === 402)
    }
  }

  const value = useMemo(
    () => ({
      ...state,
      setUser,
      showModal,
      closeModal,
      toggleModalLogin,
      setModalLive,
      setModalBan,
      setSignKey,
      logOut,
      dataEvent,
      setDataEvent,
      isRedirectEvent,
      setIsRedirectEvent,
      dataSubscription,
      setDataSubscription
    }),
    [state]
  )
  return <MyContext.Provider value={value} {...props} />
}

const useStore = () => {
  const context = useContext(MyContext)
  if (context === undefined) {
    throw new Error(`useUI must be used within a UIProvider`)
  }
  return context
}

export default useStore
